var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLighting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6795 15.0091C13.4293 14.5753 14.0838 13.9949 14.6038 13.3072C14.4445 13.0642 14.3227 12.7796 14.2512 12.4534L14.2265 12.3403C14.0814 11.6777 13.5499 11.1686 12.8816 11.0523C10.2076 10.5871 10.2075 6.74846 12.8816 6.28324C13.5281 6.17077 14.0466 5.69072 14.2111 5.05968C13.0313 3.77272 11.3363 2.96582 9.4528 2.96582C5.88875 2.96582 2.99951 5.85506 2.99951 9.41911C2.99951 11.8077 4.29727 13.8933 6.22616 15.0091V16.5177C6.22616 17.2306 6.80401 17.8084 7.51682 17.8084H11.3888C12.1016 17.8084 12.6795 17.2306 12.6795 16.5177V15.0091ZM6.22616 20.067C6.22616 19.5325 6.65955 19.0991 7.19415 19.0991H11.7115C12.2461 19.0991 12.6795 19.5325 12.6795 20.067C12.6795 20.6016 12.2461 21.035 11.7115 21.035H7.19415C6.65955 21.035 6.22616 20.6016 6.22616 20.067ZM15.622 5.18223C15.8583 4.10281 17.3952 4.09609 17.641 5.1734L17.6526 5.22433C17.6603 5.25905 17.6677 5.29112 17.6756 5.32455C17.9586 6.53014 18.9342 7.45134 20.1556 7.66382C21.2814 7.85969 21.2814 9.47589 20.1556 9.67176C18.9278 9.88538 17.9482 10.8153 17.6711 12.0304L17.641 12.1622C17.3952 13.2395 15.8583 13.2328 15.622 12.1533L15.5973 12.0402C15.3303 10.8207 14.352 9.88387 13.1221 9.6699C11.9983 9.47439 11.9983 7.86119 13.1221 7.66569C14.3478 7.45246 15.3235 6.52139 15.5944 5.30808L15.6127 5.22485L15.622 5.18223Z",
    fill: "#8C8B8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/lighting.322f4fc32a16e250699742d7173032e9.svg";
export { ForwardRef as ReactComponent };